import { Box, Typography } from "@mui/material";
import React from "react";
import "../../../styles/styles.css";
import { Captain } from "../../../types/Captain";
import {
    captainHeader,
    // captainImg,
    captainInfoContainer,
    captainInfoSubtitle,
    captainInfoText,
    captainInfoTitle,
} from "./captainInfoStyles";

interface CaptainInfoProps {
    captain: Captain;
}
const CaptainInfo: React.FC<CaptainInfoProps> = ({ captain }) => {
    return (
        <Box sx={captainInfoContainer}>
            <Box sx={captainHeader}>
                <Box>
                    <Typography variant="h4" sx={captainInfoTitle}>
                        {captain.firstName}
                    </Typography>
                    <Typography variant="h5" sx={captainInfoSubtitle}>
                        {captain.lastName}
                    </Typography>
                </Box>
                {/* <Box
                    component="img"
                    src={`/images/captains/uwe-seeler-test.webp`}
                    alt={`${captain.firstName} ${captain.lastName}`}
                    sx={captainImg}
                /> */}
            </Box>

            <Typography variant="body1" sx={captainInfoText}></Typography>
        </Box>
    );
};

export default CaptainInfo;
